import React, { Component } from 'react';
import { unsubscribeComponent } from '../../utils/unsubscribeComponent';
import { getDisplayName } from '../../utils/hocHelpers';

export default function withSubscription(WrappedComponent) {
  return class extends Component {
    static displayName = `WithSubscription(${getDisplayName(WrappedComponent)})`;

    state = {
      subscriptions: {}
    };

    componentWillUnmount() {
      unsubscribeComponent(this.state.subscriptions);
    }

    setSubscriptions = (updates) => {
      this.setState((state) => ({
        subscriptions: {
          ...state.subscription,
          ...updates
        }
      }));
    };

    render() {
      return (
        <WrappedComponent
          subscriptions={this.state.subscriptions}
          setSubscriptions={this.setSubscriptions}
          {...this.props}
        />
      );
    }
  };
}
